/* eslint-disable no-console */
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

const COMPONENT_ATTRIBUTE = 'data-react-component';
const COMPONENT_PROPS_ATTRIBUTE = 'data-react-props';

function unmountComponents() {
  const containers = document.querySelectorAll(`[${COMPONENT_ATTRIBUTE}]`);

  containers.forEach((containerElement) => {
    unmountComponentAtNode(containerElement);
  });
}

function readJsonData(element, attribute) {
  const text = attribute
    ? element?.getAttribute(attribute)
    : element?.textContent;
  const data =
    typeof text === 'string' ? JSON.parse(text.trim() || 'null') : null;
  if (data != null && typeof data === 'object') {
    return data;
  }
  return {};
}

function doMount(registeredComponents) {
  // Retrieve component mount points and their props following this pattern:
  // <div data-react-component="name" data-react-props="<%= some_props.to_json %>"></div>
  const componentMountPoints = document.querySelectorAll(
    `[${COMPONENT_ATTRIBUTE}]`
  );

  componentMountPoints.forEach((containerElement) => {
    const name = containerElement.getAttribute(COMPONENT_ATTRIBUTE);
    const props = readJsonData(containerElement, COMPONENT_PROPS_ATTRIBUTE);

    if (
      name &&
      Object.prototype.hasOwnProperty.call(registeredComponents, name)
    ) {
      const Component = registeredComponents[name];

      render(
        <React.StrictMode>
          <Component {...props} />
        </React.StrictMode>,
        containerElement
      );
    } else if (process.env.NODE_ENV === 'development') {
      console.warn(
        `Cannot mount unknown component '${name}'.\nUse one of: ${Object.keys(
          registeredComponents
        ).join(', ')}.`
      );
    }
  });
}

export default function register(components) {
  const onReady = () => {
    doMount(components);
  };

  document.addEventListener('turbo:before-render', unmountComponents);
  document.addEventListener('turbo:load', onReady);
  document.addEventListener('turbo:frame-load', onReady);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
}
